const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const searchTerm = urlParams.get('q');

console.log('url redirects start');
console.log(searchTerm);

fetch(`https://etempashopifyapps-server-b.co.uk/rarewaves/endpoints/get_url_redirect.php`, {
    method: 'POST',
    mode: 'cors',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        term: searchTerm.toLowerCase()
    })
})
.then(response => response.json())
.then(data => {
    console.log(data);
    if (data.failed) {
        console.error(data.error_message);
    }
    else if (data.redirect) {
        window.location.href = data.redirect;
    }
})
.catch(error => console.error(error));

